<div class="container-fluid p-0">
  <!-- Seção de Edição em Massa -->
  @if (clientes.length > 0 && clientesSelecionados.size > 0) {
    <div class="alert alert-warning p-3 mb-3">
      <div class="form-row">
        <!-- Placeholder para futuros campos de edição em massa -->
      </div>
      <div class="form-group d-flex align-items-start gap-2">
        <button class="btn btn-warning btn_formulario" type="button" (click)="aplicarEdicaoEmMassa()">
          ⚙️ Aplicar em Massa ({{ clientesSelecionados.size }})
        </button>
        <button class="btn btn-danger btn_formulario" type="button" (click)="removerClienteEmMassa()">
          🗑️ Remover ({{ clientesSelecionados.size }})
        </button>
        <button class="btn btn-secondary btn_formulario" type="button" (click)="limparEdicaoEmMassa()">
          Limpar
        </button>
      </div>
    </div>
  }

  <!-- Tabela de Clientes -->
  <div class="table-responsive">
    <table class="table table-sm table-hover">
      <thead>
        <tr>
          <!-- Checkbox Selecionar Todos -->
          <th class="text-center" style="width: 40px;">
            <input type="checkbox" [checked]="todosSelecionados" (change)="selecionarTodos()" />
          </th>

          <th></th>
          <th class="text-center tabela_borda">Código</th>
          <th class="tabela_borda">Cliente</th>
          <th class="text-center tabela_borda">CNPJ/CPF</th>
          <th class="tabela_borda">Endereço</th>
        </tr>
      </thead>

      <tbody>
        @for (cliente of clientes; track cliente; let i = $index) {
          <tr>
            <!-- Checkbox Selecionar -->
            <td class="text-center">
              <input type="checkbox" [checked]="estaClienteSelecionado(cliente.idcliente)" (change)="selecionarCliente(cliente.idcliente)" />
            </td>
            <!-- Ícone de Editar -->
            <td class="text-center tabela_acao">
              <span title="Clique nas células para editar">✏️</span>
            </td>
            <!-- Código -->
            <td class="text-center tabela_borda">{{ cliente.idcliente }}</td>
            <!-- Cliente (Editável) -->
            <td class="tabela_borda" (click)="iniciarEdicao(i, 'name')" style="cursor: pointer; padding: 0.25rem;">
              <!-- Modo Visualização -->
              @if (!estaEditando(i, 'name')) {
                <span>
                  {{ cliente.name }}
                </span>
              }
              <!-- Modo Edição -->
              @if (estaEditando(i, 'name')) {
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [(ngModel)]="cliente.name"
                  (blur)="finalizarEdicao(i, 'name')"
                  (keyup.enter)="finalizarEdicao(i, 'name')"
                  (keyup.escape)="cancelarEdicao(i)"
                  autofocus />
              }
            </td>
            <!-- CNPJ/CPF -->
            <td class="text-center tabela_borda">{{ cliente.client_document }}</td>
            <!-- Endereço (Editável) -->
            <td class="tabela_borda" (click)="iniciarEdicao(i, 'endereco_completo')" style="cursor: pointer; padding: 0.25rem;">
              <!-- Modo Visualização -->
              @if (!estaEditando(i, 'endereco_completo')) {
                <span>
                  {{ cliente.endereco_completo }}
                </span>
              }
              <!-- Modo Edição -->
              @if (estaEditando(i, 'endereco_completo')) {
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [(ngModel)]="cliente.endereco_completo"
                  (blur)="finalizarEdicao(i, 'endereco_completo')"
                  (keyup.enter)="finalizarEdicao(i, 'endereco_completo')"
                  (keyup.escape)="cancelarEdicao(i)"
                  autofocus />
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

</div>
